export * from './wc-promotion-vip-modal';